<template lang="html">
  <span class="atlas-city"><AtlasFlag class="atlas-city-flag" v-if="flag && city.code" :code="city.code" rounded />{{ city.name }}</span>
</template>

<script>
import db from '@/mixins/db'
import { getPlace } from './service'
export default {
  name: 'AtlasCity',
  mixins: [db],
  props: {
    coords: {
      type: Array,
      required: true
    },
    flag: {
      type: Boolean
    }
  },
  computed: {
    uid () {
      return this.coords.join('-')
    }
  },
  data () {
    return {
      loading: false,
      city: {
        name: '',
        coords: [null, null],
        distance: '',
        region: '',
        country: '',
        code: ''
      }
    }
  },
  methods: {
    setPlace () {
      // check if exists in local db
      this.getDoc('place', this.uid)
        .then(res => {
          this.city = res
        })
        .catch(err => {
          console.log(err)
          if (err.status === 404) {
            // it not get it from geonames and store it
            this.loading = true
            getPlace(this.coords).then(res => {
              const doc = Object.assign({ _id: this.uid }, res)
              this.saveDoc('place', doc)
              this.city = res
            }).finally(() => {
              this.loading = false
            })
          }
        })
    }
  },
  created () {
    this.setPlace()
  }
}
</script>

<style lang="scss">
.atlas-city-flag {
  margin-right: 5px;
}
</style>
